<!--suppress UnterminatedStatementJS -->
<template>
    <div v-if="modelKeyboardId != null">
        <span v-if="modelKeyboardId != null">Клавиатура:</span>
        <v-flex xs12 v-for="(tab, indexRow) in buttons"
                :key="indexRow">
            <v-card
                    color="transparent"
                    :flat="elevationKeyboard"
                    v-show="modelKeyboardId != null"
            >
                <draggable v-model="buttons[indexRow]" class="v-tabs__container"
                           v-bind="{group:'buttons'}"
                           @start="isDragging=true" @end="isDragging=false"
                           :move="checkMove"
                >
                    <v-btn v-for="(button, indexCol) in buttons[indexRow]"
                           :disabled="!edit"
                           :color="button.color"
                           :key="button.id"
                           depressed
                           class="ma-1 pa-2"
                           @click="editButtonIndex = [indexRow, indexCol]"
                    >
                        <span class="text-none caption">
                            {{ button.label | truncate(11, '...') }}
                        </span>
                    </v-btn>

                    <v-btn
                            color="blue lighten-2"
                            text
                            depressed
                            class="ma-1 pa-1"
                            @click="editButtonIndex = [indexRow, buttons[indexRow].length]"
                            small
                            fab
                            v-if="buttons[indexRow].length < 4 && edit"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                </draggable>
            </v-card>
        </v-flex>
        <ButtonForm :visible="showButtonForm" :buttons="buttons" :editButtonIndex="editButtonIndex"
                    @close="showButtonForm = false"
                    @saveKeyboard="changeButtons"
                    :keyboardId="modelKeyboardId"
        ></ButtonForm>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import ButtonForm from './ButtonForm'
import { mapGetters } from 'vuex'

export default {
    name: 'MessageButtonViewer',
    props: ['modelKeyboardId', 'edit'],
    components: {
        draggable,
        ButtonForm
    },
    data() {
        return {
            isDragging: false,
            elevationKeyboard: true,
            showButtonForm: false,
            editButtonIndex: [0, 0],
            snackbar: false,
            keyboardIndex: null,
            buttonsBackUp: [],
            keyboardId: null,
            buttons: [[]]
        }
    },
    methods: {
        checkMove(evt) {
            if (evt.draggedContext.element === undefined) {
                return false
            }
        },
        createKeyboard(buttons) {
            buttons = buttons.filter(function (elem) {
                if (elem.length > 0) {
                    return true
                }
            })
            this.buttons = buttons
            let keyboard = Object.assign({}, this.getKeyboardById(this.modelKeyboardId))
            keyboard.struct = buttons// this.buttons
            this.$store.dispatch('keyboards/saveKeyboard', keyboard).then(response => {
                this.snackbar = true
                // eslint-disable-next-line handle-callback-err
            }, error => {
                console.error('Got nothing from server. Prompt user to check internet connection and try again')
            })
        },
        changeButtons(params) {
            let buttons = this.buttons
            switch (params.action) {
            case 'addTempButton':
                buttons[this.editButtonIndex[0]].push({
                    label: '',
                    type: 'text',
                    color: 'primary',
                    func: 0,
                    hotkey: 0,
                    hotkey_val: null,
                    work: 1,
                    message_id: null,
                    variables: []
                })
                this.createKeyboard(buttons)
                break
            case 'removeTempButton':
                buttons[this.editButtonIndex[0]].splice(this.editButtonIndex[1], 1)
                this.createKeyboard(buttons)
                break
            case 'saveButton':
                buttons[this.editButtonIndex[0]][this.editButtonIndex[1]] = params.model
                this.createKeyboard(buttons)
                break
            case 'copyButton':
                buttons.push([])
                buttons[buttons.length - 1].push(buttons[this.editButtonIndex[0]][this.editButtonIndex[1]])
                break
            }
        }
    },
    computed: {
        ...mapGetters({
            getKeyboardById: 'keyboards/getKeyboardById',
            keyboards: 'keyboards/keyboards',
            getKeyboardIndexById: 'keyboards/getKeyboardIndexById'
        })
    },
    watch: {
        editButtonIndex() {
            if (typeof this.buttons[this.editButtonIndex[0]][this.editButtonIndex[1]] === 'undefined') {
                this.changeButtons({ action: 'addTempButton' })
            }
            this.showButtonForm = true
        },
        isDragging(newValue) {
            if (newValue) {
                this.buttons.push([])
                this.elevationKeyboard = false
                return
            }
            this.$nextTick(() => {
                let revertChanges = false
                let buttons = this.buttons.filter(function (elem) {
                    if (elem.length > 4) {
                        revertChanges = true
                    }
                    if (elem.length > 0) {
                        return true
                    }
                })
                this.elevationKeyboard = true
                if (revertChanges) { // восстановление состояния
                    this.createKeyboard(this.buttonsBackUp)
                } else {
                    this.buttonsBackUp = buttons // [].slice.call(this.buttons)
                    this.createKeyboard(buttons)
                }
            })
        },
        modelKeyboardId: {
            handler: function(value) {
                let buttons = this.getKeyboardById(value)
                if (buttons) {
                    let buttonsAsString = JSON.stringify(buttons.struct)
                    if (buttonsAsString === '{}') {
                        buttonsAsString = '[[]]'
                    }
                    this.buttons = JSON.parse(buttonsAsString)
                } else {
                    this.buttons = []
                }
            },
            immediate: true
        }
    },
    filters: {
        truncate(text, length, suffix) {
            if (text !== undefined) {
                if (text.length > length) {
                    return text.substring(0, length) + suffix
                } else {
                    return text
                }
            }
            return ''
        }
    },
    created() {
        this.keyboardId = this.modelKeyboardId
    }
}
</script>

<style scoped>

</style>
